import { useCallback, useEffect, useState } from 'react';
import { useGetCommonStore } from '@/store';
import { syncUserGroupAndLSAbVersions } from '../helpers/syncUserGroupAndLSAbVersions';

export const useSyncABTestsUserGroup = () => {
  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();
  const [isLoading, setIsLoading] = useState(false);
  const refreshUser = useCommonStore.use.refreshUser();

  const sync = useCallback(async () => {
    if (!user || isLoading) return;

    try {
      setIsLoading(true);
      const isUpdated = await syncUserGroupAndLSAbVersions(user);

      if (isUpdated) {
        await refreshUser();
      }
    } catch (err) {
      console.error('useSyncABTestsUserGroup failed:', err);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    sync();
  }, [sync]);
};
